<template>
  <el-dialog
    title="Новый офис"
    :visible="visible"
    :before-close="close"
    @opened="onOpen"
  >
    <el-form ref="addForm" :rules="addFormRules" :model="addForm">
      <el-form-item label="Название" prop="title">
        <el-input name="title" ref="autoFocus" placeholder="Введите название офиса..." v-model="addForm.title"></el-input>
      </el-form-item>
      <el-form-item label="Адрес" prop="address">
        <el-input name="address" placeholder="Введите адрес" v-model="addForm.address"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
        <el-button
          type="default"
          :loading="loadAddForm"
          @click="saveForm(false)"
        >Сохранить и создать новый офис</el-button>
        <el-button
          type="primary"
          :loading="loadAddForm"
          @click="saveForm(true)"
        >Сохранить и закрыть</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogItemAdd',
  data () {
    return {
      form: null,
      error: null,
      loadAddForm: !!0,
      addForm: {},
      addFormRules: {
        title: [
          { required: true, message: 'Укажите название', trigger: 'blur' }
        ],
        address: [
          { required: true, message: 'Введите адрес', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
  },
  props: {
    visible: {
      required: true
    }
  },
  methods: {
    onOpen () {
      this.autoFocus()
    },
    close () {
      this.$emit('close')
    },
    autoFocus () {
      this.$refs.autoFocus.focus()
    },
    saveForm (close) {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.loadAddForm = !!1

          this.$api.departments
            .create(this.addForm)
            .then(() => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Данные сохранены'
              })
              if (close) {
                this.$emit('update')
                this.$emit('close')
              } else {
                this.$emit('update')
                this.addForm = {
                  type: '20'
                }
                this.autoFocus()
              }
            })
            .catch((response) => {
              this.$notify.error({
                title: 'Ошибка',
                message: response.response.data.message
              })
            })
            .finally(() => {
              this.loadAddForm = !!0
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

.dialog {
  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #aaaeba;
    margin: 25px 0 40px 0;

    &_mini {
      font-size: 14px;
    }
  }

  &__select {
    margin: 10px 0;
    width: 100%;
  }
  &__btns {
    float: right;
  }
}

</style>
